
import URI from 'urijs';

import {
    ADD_COMMAND,
    REMOVE_COMMAND,
    SELECT_MODE,
    SET_INITIALIZED
} from '../sagas/multiscene';

const initialState = {
    initialized: false,
    // mode of window (PANO,PANO+POINT,POINT)
    mode: null,
    commands: {
        lastUsedId: 0,
        list: []
    }
};

function addCommand(state, name, params) {
    let lastUsedId = state.commands.lastUsedId + 1;
    return {
        lastUsedId: lastUsedId,
        list: [
            ...state.commands.list,
            {
                id: lastUsedId,
                name,
                params
            }
        ]
    };
}

function getInitialState() {
    return {
        ...initialState,
        mode: getModeFromUrl()
    };
}

function getModeFromUrl() {
    let uri = new URI(window.location.href);
    let mode = uri.search(true).mode;
    return mode;
}

function removeCommand(state, id) {
    return {
        ...state.commands,
        list: state.commands.list.filter(item => {
            return (item.id !== id);
        })
    }
}

function multiScene(state = getInitialState(), action) {
    switch (action.type) {
        case ADD_COMMAND:
            return {
                ...state,
                commands: addCommand(state, action.name, action.params)
            };

        case REMOVE_COMMAND:
            return {
                ...state,
                commands: removeCommand(state, action.id)
            }

        case SELECT_MODE:
            return {
                ...state,
                mode: action.mode
            };

        case SET_INITIALIZED:
            return {
                ...state,
                initialized: action.value
            };

        default:
            return state;
    }
}

export default multiScene;
